module.exports = __webpack_public_path__ + "static/img/1_7_2.e0925135.jpg";